import { useContext } from 'react'

import { AccountFormContext } from '../context'

export function useCategory() {
  const {
    categories,
    loadingCategories: loading,
    listCategories
  } = useContext(AccountFormContext)

  return {
    categories,
    loading,
    listCategories
  }
}
